<template>
  <div>
    <b-overlay
        id="overlay-background"
        :show="loader === true"
        variant="dark"
        opacity="0.85"
        blur="2px"
        rounded="sm"
        spinner-variant="primary"
        spinner-medium
    >
      <b-card>
        <div class="m-2">
          <b-row>
            <b-col
                cols="12"
                md="6"
                class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
            >
              <label>{{ $t('DEBTIA_SHOWING') }}</label>
              <v-select
                  v-model="perPage"
                  :clearable="false"
                  class="per-page-selector d-inline-block mx-50"
                  :options="perPageOptions"
              />
              <label>{{ $t('DEBTIA_ENTRIES') }}</label>
            </b-col>
            <b-col
                cols="12"
                md="5"
                offset-md="1"
            >
              <div class="d-flex align-items-center justify-content-end">
                <b-form-input
                    v-model="searchQuery"
                    class="d-inline-block mr-1"
                    :placeholder="$t('DEBTIA_SEARCH')"
                />
              </div>
            </b-col>
          </b-row><br>
          <b-row>
            <b-col
                cols="12"
                md="6"
                class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
            >
              <label>{{ $t('DEBTIA_SEARCH_BY') }}</label>
              <v-select
                  v-model="searchBy"
                  :clearable="false"
                  class="per-page-selector d-inline-block mx-50"
                  :options="searchByOptions"
              />
            </b-col>
            <b-col
                cols="12"
                md="5"
                offset-md="1"
            >
              <div class="d-flex align-items-center justify-content-end">
                <b-input-group style="margin-right: 10px">
                  <b-form-input
                      id="example-input"
                      v-model="fromdate"
                      type="text"
                      :placeholder="$t('DEBTIA_FROM')"
                      autocomplete="off"
                      show-decade-nav
                  />
                  <b-input-group-append>
                    <b-form-datepicker
                        v-model="fromdate"
                        show-decade-nav
                        button-only
                        button-variant="outline-primary"
                        right
                        size="sm"
                        locale="en-US"
                        aria-controls="example-input"
                    />
                  </b-input-group-append>
                </b-input-group>
                <b-input-group>
                  <b-form-input
                      id="example-input"
                      v-model="tilldate"
                      type="text"
                      :placeholder="$t('DEBTIA_TILL')"
                      autocomplete="off"
                      show-decade-nav
                  />
                  <b-input-group-append>
                    <b-form-datepicker
                        v-model="tilldate"
                        show-decade-nav
                        button-only
                        button-variant="outline-primary"
                        right
                        size="sm"
                        locale="en-US"
                        aria-controls="example-input"
                    />
                  </b-input-group-append>
                </b-input-group>
              </div>
            </b-col>
          </b-row>
        </div>
        <b-table
            ref="roles"
            class="position-relative"
            :fields="logsFields"
            :items="logsData"
        >
          <template #cell(template)="data">
            {{ data.item.templateName }}
          </template>
          <template #cell(receiver)="data">
            <div >
              {{ data.item.status_code }}
            </div>
          </template>
          <template #cell(date)="data">
            {{ data.item.received_at }}
          </template>
          <template #cell(action)="data">
            <feather-icon
                v-b-modal.modal-role
                icon="EyeIcon"
                @click="getLog(data.item)"
            />
          </template>
        </b-table>
        <div class="mx-2 mb-2">
          <b-row>

            <b-col
                cols="12"
                sm="6"
                class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
              <span class="text-muted">{{ $t('DEBTIA_SHOWING') }} {{ from }} to {{ to }} of {{ totalPages }} {{ $t('DEBTIA_ENTRIES') }}</span>
            </b-col>
            <!-- Pagination -->
            <b-col
                cols="12"
                sm="6"
                class="d-flex align-items-center justify-content-center justify-content-sm-end"
            >

              <b-pagination
                  v-model="currentPage"
                  :total-rows="totalPages"
                  :per-page="perPage"
                  first-number
                  last-number
                  class="mb-0 mt-1 mt-sm-0"
                  prev-class="prev-item"
                  next-class="next-item"
              >
                <template #prev-text>
                  <feather-icon
                      icon="ChevronLeftIcon"
                      size="18"
                  />
                </template>
                <template #next-text>
                  <feather-icon
                      icon="ChevronRightIcon"
                      size="18"
                  />
                </template>
              </b-pagination>

            </b-col>

          </b-row>
        </div>
        <logs-modal
            :log-data="showData"
            :modal-loads="modalLoader"
            :show="!modalLoader"
            :reload-method="getLogs"
        />
      </b-card>
    </b-overlay>
  </div>
</template>

<script>
import {
  BCard, BOverlay, BTable, BRow, BCol, BFormInput, BPagination, BFormDatepicker, BInputGroupAppend, BInputGroup,
} from 'bootstrap-vue'
import axios from '@axios'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import vSelect from 'vue-select'
import constants from '@/app-configs/constants'
import i18n from '@/libs/i18n'
import LogsModal from './LogsModal.vue'

export default {
  components: {
    BCard,
    BOverlay,
    BTable,
    BRow,
    BCol,
    vSelect,
    BFormInput,
    BPagination,
    LogsModal,
    BFormDatepicker,
    BInputGroupAppend,
    BInputGroup,
  },
  data() {
    return {
      loader: false,
      logsData: [],
      perPage: 10,
      searchBy: 'All',
      perPageOptions: [10, 25, 50, 100],
      searchByOptions: ['All', 'SMS', 'Email'],
      searchQuery: '',
      totalPages: 0,
      from: 0,
      to: 0,
      currentPage: 1,
      showData: {},
      modalLoader: true,
      constants,
      fromdate: '',
      tilldate: '',
      user_type: JSON.parse(localStorage.getItem('userData')).data.name,
    }
  },
  computed: {
    logsFields() {
      let fields = []
      if (this.user_type === 'Super Admin') {
        fields = [
          { key: 'id', sortable: true },
          { key: 'status_code', label: i18n.t('DEBTIA_STATUS_CODE') },
          { key: 'received_at', label: i18n.t('DEBTIA_RECEIVED_AT') },
          { key: 'content', sortable: true, label: i18n.t('DEBTIA_CONTENT') },
          { key: 'action', label: i18n.t('DEBTIA_ACTION') },
        ]
      } else {
        fields = [
          { key: 'id', sortable: true },
          { key: 'status_code', label: i18n.t('DEBTIA_STATUS_CODE') },
          { key: 'received_at', label: i18n.t('DEBTIA_RECEIVED_AT') },
          { key: 'content', sortable: true, label: i18n.t('DEBTIA_CONTENT') },
          { key: 'action', label: i18n.t('DEBTIA_ACTION') },
        ]
      }
      return fields
    },
  },
  watch: {
    searchQuery: {
      handler() {
        this.getLogs()
      },
    },
    currentPage: {
      handler() {
        this.getLogs()
      },
    },
    perPage: {
      handler() {
        this.currentPage = 1
        this.getLogs()
      },
    },
    searchBy: {
      handler() {
        this.getLogs()
      },
    },
    fromdate: {
      handler() {
        this.getLogs()
      },
    },
    tilldate: {
      handler() {
        this.getLogs()
      },
    },
  },
  created() {
    this.getLogs()
  },
  methods: {
    getReceiver(item, type) {
      console.log('item', item)
      let result = ''
      let cc = ''
      let bcc = ''
      if (type === 'email') {
        const receiver = JSON.parse(item)
        const to = `To: ${receiver.to}`
        if ((receiver.cc).length > 0) {
          cc = `${cc} CC: `
          receiver.cc.forEach((value, i) => {
            const ccItem = `${i !== 0 ? ', ' : ''} ${value}`
            cc = `${cc} ${ccItem}`
          })
        }
        if ((receiver.bcc).length > 0) {
          bcc = `${bcc} BCC: `
          receiver.bcc.forEach((value, i) => {
            const bccItem = `${i !== 0 ? ', ' : ''} ${value}`
            bcc = `${bcc} ${bccItem}`
          })
        }
        const sresult = {
          to, cc, bcc,
        }
        result = sresult
      } else {
        result = item
      }
      // return `Hello${item}`
      return result
    },
    async getLogs() {
      let search = ''
      try {
        this.loader = true
        if (this.searchBy !== 'All') {
          search = this.searchBy
        }
        const url = 'get-all-failed-sms-response-logs'
        const logs = await axios.get(`${constants.communicationBaseUrl}v1/sms/${url}?q=${this.searchQuery}&from=${this.fromdate}&to=${this.tilldate}&type=${search}&perPage=${this.perPage}&page=${this.currentPage}`)
        console.log('logging', logs)
        if (logs.status) {
          this.logsData = logs.data.data
          this.totalPages = logs.data.total
          this.from = logs.data.from
          this.to = logs.data.to
          this.currentPage = logs.data.current_page
          this.loader = false
        }
      } catch (error) {
        this.$toast({
          component: ToastificationContent,
          position: 'top-right',
          props: {
            title: 'Error',
            icon: 'CoffeeIcon',
            variant: 'danger',
            text: error,
          },
        })
      }
    },
    async getLog(item) {
      this.modalLoader = true
      this.showData = item
      this.modalLoader = false
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
